import { useNavigate } from 'react-router-dom';
import { routesForRedirect } from '@app/configs/router/routes';
import { Button } from 'antd';
import styled from 'styled-components';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  min-height: 100dvh;
`;

const Title = styled.h1`
  font: var(--font-xxxl);
  margin-bottom: var(--spacing-s);
`;

const Description = styled.h2`
  font: var(--font-xl);
  margin-bottom: var(--spacing-s);
`;

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoToHome = () => navigate(routesForRedirect.default);

  return (
    <Container>
      <Title>404</Title>
      <Description>Không tìm thấy trang</Description>
      <Button onClick={handleGoToHome} type='primary'>
        Về trang chủ
      </Button>
    </Container>
  );
};

export default NotFound;
